<template>
	<button type="button" :class="`px-2 py-1 flex items-center gap-3 rounded-lg ${selectedDirectory === directory.path ? 'bg-gray-100 dark:bg-gray-800' : 'hover:bg-gray-100 dark:hover:bg-gray-800'}`" @click.stop="toggleChildren" @dblclick.stop="emit('selected', directory.path)">
		<i class="fa-solid fa-folder text-blue-600"/>
		<span class="grow text-left text-sm truncate">{{ directory.label }}</span>
	</button>
	<div v-if="showChildren" class="pl-3 flex flex-col gap-1">
		<FileManagerDirectory v-for="child in directory.children" :key="`file-manager-directory-${selectedDirectory}-${child.path}`" :directory="child" :selected-directory="selectedDirectory" @selected="emit('selected', $event)"/>
	</div>
</template>
<script setup lang="ts">
import {ref, type Ref, defineProps, defineEmits, type ComputedRef, computed} from 'vue'
import {type FileManagerDirectory as FileManagerDirectoryType} from '@/Types/System/FileManager/FileManagerDirectory'

const props = defineProps<{
	selectedDirectory:string,
	directory:FileManagerDirectoryType,
}>()

const emit = defineEmits([
	'selected',
])

const selectedDirectory:Ref<string> = ref(props.selectedDirectory)
const directory:Ref<FileManagerDirectoryType> = ref(props.directory)

const showChildren:ComputedRef<boolean> = computed(():boolean => {
	if(directory.value.children.length === 0){
		return false
	}
	return directory.value.open || hasSelectedChild()
})

function toggleChildren():void{
	if(directory.value.children.length > 0){
		directory.value.open = !directory.value.open
	}
}

function hasSelectedChild():boolean{
	return directory.value.children.find((child:FileManagerDirectoryType) => child.path.startsWith(selectedDirectory.value)) !== undefined
}
</script>